import {
  FEEDBACK_TYPES_IN_ORDER,
  Feedback,
  FeedbackCreateDTO,
  FeedbackTypeEnum,
} from '@/models/Feedback';
import { normalizeTranslatableField } from '@/utils/translatable-field/normalizeTranslatableField';

const emptyDict = () => ({ en: '', 'pt-br': '' });

export const buildEmptyFeedback = (
  type: FeedbackTypeEnum,
): FeedbackCreateDTO => ({
  type,
  title: emptyDict(),
  message: emptyDict(),
});

export const adapterFeedbacks = (
  feedbacks: Feedback[] = [],
): FeedbackCreateDTO[] =>
  FEEDBACK_TYPES_IN_ORDER.map(type => {
    const existing = feedbacks.find(fb => fb.type === type);
    if (!existing) return buildEmptyFeedback(type);
    return {
      id: existing.id,
      type,
      title: normalizeTranslatableField(existing.title),
      message: normalizeTranslatableField(existing.message),
    };
  });

const hasContent = (fb: FeedbackCreateDTO) => {
  const titleEn = fb.title?.en?.trim() ?? '';
  const titlePtBr = fb.title?.['pt-br']?.trim() ?? '';
  const messageEn = fb.message?.en?.trim() ?? '';
  const messagePtBr = fb.message?.['pt-br']?.trim() ?? '';
  return !!(titleEn || titlePtBr || messageEn || messagePtBr);
};

export const sanitizeFeedbacks = (
  feedbacks: FeedbackCreateDTO[] = [],
): FeedbackCreateDTO[] => feedbacks.filter(hasContent);
